import React from 'react';
import classNames from 'classnames';
import { RSFormLabel } from 'reactsymbols-kit';
import type { IMethod } from '../../stores/model/metamodel/method';

export interface MethodSelectProps {
  /** The list of possible methods. */
  methods: IMethod[];
  /** The ids of the selected methods. */
  selected: string[];
  /** Change handler — receives the new list of selected ids. */
  onChange: (selected: string[]) => void;
  /** Show a label with 'Choose methods'? Default: true. */
  showHelp?: boolean;
}

/**
 * A select component for Methods. Used a.o. to select the methods to use for a
 * transition.
 */
const MethodSelect = ({ methods, selected, onChange, showHelp = true }: MethodSelectProps) => {
  const toggleMethod = (id: string) => {
    if (selected.includes(id)) {
      onChange(selected.filter(s => s !== id));
    } else {
      onChange(selected.concat([id]));
    }
  };

  return (
    <div className="method-selector">
      {showHelp && <RSFormLabel>Choose methods</RSFormLabel>}
      {methods.map(m => {
        const isSelected = selected.includes(m.id);
        return (
          <div
            key={m.id}
            className={classNames('method cursor-pointer p-2.5', {
              'bg-primary text-white': isSelected,
            })}
            onClick={() => toggleMethod(m.id)}
          >
            {m.displayStringWithMetadata}
          </div>
        );
      })}
    </div>
  );
};

export default MethodSelect;
